import React from 'react';
import { Image } from '../Image/Image.es.js';
import '../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import 'nanoid/non-secure';
import { Brand } from './styled.es.js';

const NavBarBrand = ({ src, width, height, href, onClick, children }) => /* @__PURE__ */ React.createElement(Brand, {
  as: href ? "a" : "div",
  href: href || "",
  onClick
}, src && /* @__PURE__ */ React.createElement(Image, {
  src,
  alt: "logo",
  width,
  height
}), children && children);
NavBarBrand.displayName = "NavBar.Brand";

export { NavBarBrand };
//# sourceMappingURL=NavBarBrand.es.js.map
